// extracted by mini-css-extract-plugin
var _1 = "DeleteAccountContent-module__hr___EgbXX";
var _2 = "DeleteAccountContent-module__list___yJxLO";
export { _1 as "hr", _2 as "list" }
